'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogLocationRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogLocationRemote = exports.CatalogLocationRemote = {
    fetchCatalogLocations: function fetchCatalogLocations(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ deployment: deployment, path: '<ITEM-API>catalog-locations' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalogLocation.js
// module id = EuUL
// module chunks = 60